'use client'
import React, { useEffect, useRef } from 'react'
import { useFormConfigContext } from 'src/components/era-package/forms/hooks/useFormConfig'
import AbiTradePartnerApiUrls from '../../../../../apiUrls/AbiTradePartnerApiUrls'
import { useWatch } from 'react-hook-form'
import { FileForUserGetPartyId } from '../../../../../common/FileForUserCommon'

export const Interceptor = ({ asyncDefaultValues }) => {
  const isFirstLoad = useRef(true)
  const rhf = useFormConfigContext()
  const imptRecordNoRaw = rhf.watch('header.importerOfRecordNumber')
  const imptRecordNoConfirm = rhf.watch('confirmation.importerOfRecordNumber')
  const ucNumberRaw = rhf.watch('header.ultimateConsigneeNumber')
  const ffNumberRaw = rhf.watch('header.freightForwarder')
  const dnNumberRaw = rhf.watch('header.designatedNotifyPartyNumber')

  // Normalize: strip embedded internal ID from old-format values ("taxId - internalId" → "taxId")
  const normalizeTaxId = (val) => (val?.includes(' - ') ? val.split(' - ')[0] : val)
  const imptRecordNo = normalizeTaxId(imptRecordNoRaw)
  const ucNumber = normalizeTaxId(ucNumberRaw)
  const ffNumber = normalizeTaxId(ffNumberRaw)
  const dnNumber = normalizeTaxId(dnNumberRaw)
  const partyLookup = useWatch({
    control: rhf.control,
    name: [
      'cargo.SE-partyMasterId',
      'cargo.BY-partyMasterId',
      'cargo.CN-partyMasterId',
      'cargo.ST-partyMasterId',
      'cargo.LG-partyMasterId',
      'cargo.CS-partyMasterId'
    ]
  })

  useEffect(() => {
    rhf.setValue(
      'confirmation.importerOfRecordNumber',
      imptRecordNoConfirm?.split(' - ')[0]
    )
  }, [imptRecordNoConfirm])

  useEffect(() => {
    let isAlive = true
    if (!imptRecordNo) {
      rhf.setValue('header.bond', [])
    } else {
      let newObj = {}
      if (normalizeTaxId(asyncDefaultValues.header.importerOfRecordNumber) === imptRecordNo) {
        if (asyncDefaultValues.header?.bond[0]?.bondDesignationType) {
          newObj = {
            ...newObj,
            bondDesignationType:
              asyncDefaultValues.header?.bond[0]?.bondDesignationType
          }
        } else {
          newObj = {
            ...newObj,
            bondDesignationType: 'B'
          }
        }
      } else {
        newObj = {
          ...newObj,
          bondDesignationType: 'B'
        }
      }

      if (isFirstLoad.current && asyncDefaultValues.header?.bond[0]) {
        newObj = {
          ...newObj,
          ...asyncDefaultValues.header?.bond[0]
        }
        rhf.setValue('header.bond', [newObj])
        isFirstLoad.current = false
      } else {
        fetch(AbiTradePartnerApiUrls.GET + `?partyId=${FileForUserGetPartyId()}&partyCode=IM`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
          }
        })
          .then((res) => res.json())
          .then((json) => {
            const partner = json.data?.find((p) => p.taxIdNumber === imptRecordNo)
            if (partner && isAlive) {
              newObj = { ...newObj, ...partner }
              rhf.setValue('header.bond', [newObj])
              rhf.setValue('header.importerName', partner.name || '')
            }
          })
          .catch((err) => {
            console.error(err)
          })
      }

      return () => {
        isAlive = false
      }
    }
  }, [imptRecordNo])

  useEffect(() => {
    let isAlive = true
    partyLookup.forEach((item) => {
      if (item) {
        fetch(AbiTradePartnerApiUrls.GET + `?id=${item}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
          }
        })
          .then((res) => res.json())
          .then((json) => {
            let partyCode = json.data.partyCode
            if (json.data.partyCode === 'IM') {
              partyCode = 'CN'
            }
            const partyMasterName = `cargo.${partyCode}-partyMasterName`
            const currentPartyMasterName = rhf.getValues(partyMasterName)

            const name = `cargo.${partyCode}-name`
            const currentName = rhf.getValues(name)

            if (
              currentPartyMasterName !== json.data.partyMasterName &&
              currentName !== json.data.name
            ) {
              rhf.setValue(partyMasterName, json.data.partyMasterName)
              rhf.setValue(name, json.data.name)
              rhf.setValue(`cargo.${partyCode}-address1`, json.data.address1)
              rhf.setValue(`cargo.${partyCode}-address2`, json.data.address2)
              rhf.setValue(
                `cargo.${partyCode}-partyIdentifier`,
                json.data.partyIdentifier
              )
              rhf.setValue(`cargo.${partyCode}-duns`, json.data.duns)
              rhf.setValue(`cargo.${partyCode}-city`, json.data.city)
              rhf.setValue(
                `cargo.${partyCode}-stateProvince`,
                json.data.stateProvince
              )
              rhf.setValue(
                `cargo.${partyCode}-postalCode`,
                json.data.postalCode
              )
              rhf.setValue(
                `cargo.${partyCode}-countryCode`,
                json.data.countryCode
              )
            }
          })
          .catch((err) => {
            console.error(err)
          })

        return () => {
          isAlive = false
        }
      }
    })
  }, [partyLookup])

  useEffect(() => {
    if (!ucNumber) return
    fetch(AbiTradePartnerApiUrls.GET + `?partyId=${FileForUserGetPartyId()}&partyCode=CN`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      }
    })
      .then((res) => res.json())
      .then((json) => {
        const partner = json.data?.find((p) => p.taxIdNumber === ucNumber)
        if (partner) rhf.setValue('header.ultimateConsigneeName', partner.name || '')
      })
      .catch(console.error)
  }, [ucNumber])

  useEffect(() => {
    if (!ffNumber) return
    fetch(AbiTradePartnerApiUrls.GET + `?partyId=${FileForUserGetPartyId()}&partyCode=FF`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      }
    })
      .then((res) => res.json())
      .then((json) => {
        const partner = json.data?.find((p) => (p.taxIdNumber || String(p.id)) === ffNumber)
        if (partner) rhf.setValue('header.freightForwarderName', partner.name || '')
      })
      .catch(console.error)
  }, [ffNumber])

  useEffect(() => {
    if (!dnNumber) return
    fetch(AbiTradePartnerApiUrls.GET + `?partyId=${FileForUserGetPartyId()}&partyCode=DN`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      }
    })
      .then((res) => res.json())
      .then((json) => {
        const partner = json.data?.find((p) => p.taxIdNumber === dnNumber)
        if (partner) rhf.setValue('header.designatedNotifyPartyName', partner.name || '')
      })
      .catch(console.error)
  }, [dnNumber])

  // return empty node
  return <></>
}
